import React, { Component } from 'react';
import { observer } from 'mobx-react';
import styles from './guides-color-panel.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

interface IColorCellProps {
    selected: boolean;
    color: string;
    tips: string;
    handleColorChange(color: string);
}

/**
 * 参考线色板的单元格
 */
@observer
export default class GuideColorCell extends Component<IColorCellProps, any> {
    public constructor(props: IColorCellProps) {
        super(props);
    }

    public render() {
        return (
            <Tooltip
                title={this.props.tips}
                placement="bottom"
            >
                <div
                    onClickCapture={() => {
                        this.props.handleColorChange(this.props.color);
                    }}
                    className={styles.guideColorCell}
                    style={{
                        backgroundColor: `#${this.props.color}`,
                    }}
                >
                    <div className={`${this.props.selected ? styles.guideColorSelected : ''} ${styles.guideColorHover}`}></div>
                </div>
            </Tooltip>
        );
    }
}
